export function useLayers(map) {
  function initListeners(layerId) {
    map?.on('mousemove', layerId, ({
      features
    }) => {
      if (features && features.length > 0 && features[0].properties?.movable) {
        map.getCanvas().style.cursor = 'move';
      }
    });
    map?.on('mouseleave', layerId, () => {
      map.getCanvas().style.cursor = '';
    });
  }
  function addCircleLayer(layerId, sourceId, paint, {
    before,
    filter,
    disableCursorChange,
    minzoom,
    maxzoom
  } = {}) {
    if (!map || map.getLayer(layerId)) return;
    map.addLayer({
      id: layerId,
      type: 'circle',
      source: sourceId,
      paint: {
        ...paint
      },
      ...(filter ? {
        filter
      } : {}),
      ...(minzoom ? {
        minzoom
      } : {}),
      ...(maxzoom ? {
        maxzoom
      } : {})
    }, before);
    if (!disableCursorChange) initListeners(layerId);
  }
  function addLineLayer(layerId, sourceId, layout, paint, {
    filter,
    before,
    minzoom,
    maxzoom
  } = {}) {
    if (!map || map.getLayer(layerId)) return;
    map.addLayer({
      id: layerId,
      type: 'line',
      source: sourceId,
      layout: {
        ...layout
      },
      paint: {
        ...paint
      },
      ...(filter ? {
        filter
      } : {}),
      ...(minzoom ? {
        minzoom
      } : {}),
      ...(maxzoom ? {
        maxzoom
      } : {})
    }, before || 'labels');
    initListeners(layerId);
  }
  function getLayerOpacities(layers, sourceId) {
    const layerOpacities = {};
    layers.forEach(layer => {
      if ('source' in layer && layer.source === sourceId) {
        if (layer.type === 'fill') {
          layerOpacities[layer.id] = layer.paint?.['fill-opacity'];
        } else if (layer.type === 'line') {
          layerOpacities[layer.id] = layer.paint?.['line-opacity'];
        }
      }
    });
    return layerOpacities;
  }
  return {
    addCircleLayer,
    addLineLayer,
    getLayerOpacities
  };
}